export default __webpack_public_path__ + "static/media/cognota-logo.e9b52348.svg";